<template>
  <div id="pageAplicacion">
    <v-container grid-list-xl fluid>
      <div v-if="loading">
        <loading></loading>
      </div>
      <v-layout>
        <v-flex>
          <v-toolbar color="white" dark flat dense cad>
            <v-toolbar-title class="indigo--text"
              >Informe de revision de cajas</v-toolbar-title
            >
          </v-toolbar>
        </v-flex>
      </v-layout>
      <v-layout>
        <v-spacer></v-spacer>
        <v-card-actions class="pb-3">
          <v-btn
            :loading="loading"
            color="primary"
            dark
            class="mb-2"
            @click="descarga()"
            >Descargar Informe <v-icon right dark>folder</v-icon></v-btn
          >
        </v-card-actions>
      </v-layout>
      <v-layout row wrap>
        <v-flex
          lg4
          sm12
          xs12
          v-for="(item, index) in trending"
          :key="'c-trending' + index"
        >
          <circle-statistic
            :title="item.subheading"
            :sub-title="item.headline"
            :caption="item.caption"
            :icon="item.icon.label"
            :color="item.linear.color"
            :value="item.linear.value"
          >
          </circle-statistic>
        </v-flex>
      </v-layout>
      <v-layout v-if="show">
        <v-flex>
          <v-toolbar color="white" dark flat dense cad>
            <v-toolbar-title class="indigo--text"
              >Seleccione region:</v-toolbar-title
            >
          </v-toolbar>
        </v-flex>
      </v-layout>
      <v-layout v-if="show" justify-center>
        <v-flex xs12 md6>
          <v-select
            v-model="regionValue"
            item-text="nombre"
            item-value="code"
            :items="regionesSelect"
            label="Region"
            data-vv-name="listaRegiones"
          ></v-select>
        </v-flex>

        <v-spacer></v-spacer>
        <v-btn fab dark color="teal" title="Filtrar detalle" @click="filter()">
          <v-icon dark>filter_list</v-icon>
        </v-btn>
        <!-- BOTON NO INCLUIDO EN DISEÑO DEBERIA ESTAR -->
        <v-btn
          fab
          dark
          color="red darken-4"
          title="Limpiar filtros"
          @click="clear()"
        >
          <v-icon dark>clear_all</v-icon>
        </v-btn>
      </v-layout>
      <v-dialog v-model="dialogLoading" persistent max-width="390">
        <loading-descarga></loading-descarga>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";
import CircleStatistic from "@/components/widgets/statistic/CircleStatistic";
import Loading from "@/views/ui/Loading.vue";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
export default {
  components: {
    CircleStatistic,
    Loading,
    LoadingDescarga,
  },
  data: () => ({
    dialogLoading: false,
    loading: false,
    show: false,
    tipeArchive: "",
    filenameValue: "",
    filename: "",
    base64Value: "",
    respGraficaCirculo: [],
    trending: [
      {
        subheading: "Enviadas",
        headline: "0%",
        caption: " Enviadas",
        percent: 0,
        icon: {
          label: "email",
          color: "info",
        },
        linear: {
          value: new Number("0"),
          color: "info",
        },
      },
      {
        subheading: "Recepcionadas",
        headline: "0%",
        caption: " Recepcionadas",
        percent: 0,
        icon: {
          label: "list",
          color: "primary",
        },
        linear: {
          value: new Number("0"),
          color: "success",
        },
      },
      {
        subheading: "Total registros de recepción",
        headline: "0%",
        caption: " Total esperados",
        percent: 0,
        icon: {
          label: "bug_report",
          color: "primary",
        },
        linear: {
          value: new Number("0"),
          color: "error",
        },
      },
    ],
  }),

  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.dataGraficaCirculo();
  },
  computed: {},
  methods: {
    async getDataGraficoCirculo() {
      return await axios
        .get("capturaRecepcion/graphCirculo/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    async dataGraficaCirculo() {
      this.loading = true;
      this.respGraficaCirculo = await this.getDataGraficoCirculo();

      // console.log("respGraficaCirculo:" + JSON.stringify(this.respGraficaCirculo, null, 2));
      this.trending[0].headline = "" + this.respGraficaCirculo.cajasEnviadas;
      this.trending[1].headline =
        "" + this.respGraficaCirculo.cajasRecepcionadas;
      this.trending[2].headline = "" + this.respGraficaCirculo.cajasTotal;

      this.trending[0].percent = parseInt(
        this.respGraficaCirculo.cajasEnviadas
      );
      this.trending[1].percent = "no se usa!"; // parseInt(this.respGraficaCirculo.cajasRecepcionadasPerc);
      this.trending[2].percent = parseInt(this.respGraficaCirculo.cajasTotal);

      this.trending[0].linear.value = this.respGraficaCirculo.cajasEnviadasPerc;
      this.trending[1].linear.value =
        this.respGraficaCirculo.cajasRecepcionadasPerc;
      this.trending[2].linear.value = 100.0;

      this.loading = false;
    },
    async descarga() {
      this.dialogLoading = true;
      this.res = await this.downloadComplete();
      this.dialogLoading = false;
    },

    async downloadComplete() {
      let idContrato = this.$store.getters.contratoStored;

      return await axios
        .get("capturaRecepcion/informeRecepcion/" + idContrato, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", "informeCaptura.xlsx");
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>
